import { render, staticRenderFns } from "./Holidays.vue?vue&type=template&id=367d6fd5"
import script from "./Holidays.vue?vue&type=script&lang=js"
export * from "./Holidays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/atlassian/application-data/bamboo/local-working-dir/AG-FRTPRSTD0-JOBCOMPILAR/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('367d6fd5')) {
      api.createRecord('367d6fd5', component.options)
    } else {
      api.reload('367d6fd5', component.options)
    }
    module.hot.accept("./Holidays.vue?vue&type=template&id=367d6fd5", function () {
      api.rerender('367d6fd5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Holidays.vue"
export default component.exports